"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CircleAlert, FileText } from "lucide-react";
function ArticlesGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-64 rounded-xl bg-muted/10 animate-pulse border border-border/40" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center bg-card/50 rounded-xl border border-border/50">
        <CircleAlert className="h-10 w-10 text-destructive mb-4" />
        <p className="text-muted-foreground mb-4">Makaleler yüklenirken bir hata oluştu.</p>
        <Button onClick={refetch} variant="outline">Tekrar Dene</Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-16 border border-dashed border-border/50 rounded-xl bg-card/30">
        <FileText className="h-12 w-12 text-muted-foreground/50 mx-auto mb-4" />
        <p className="text-muted-foreground text-lg">Henüz yayınlanmış bir makale bulunmuyor.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex flex-col h-full bg-card border-border/40 hover:border-primary/30 transition-all duration-300 shadow-sm hover:shadow-md">
          <CardHeader className="pb-3 space-y-4">
            <div className="flex items-center justify-between">
              <Badge variant="outline" className="font-normal text-xs bg-[#c5a059]/10 text-[#c5a059] border-[#c5a059]/30 hover:bg-[#c5a059]/20 px-2.5 py-0.5 rounded-md">
                {post.date ? new Date(post.date).toLocaleDateString('tr-TR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            }) : 'Tarih yok'}
              </Badge>
            </div>
            <CardTitle className="font-serif text-xl md:text-2xl leading-snug text-[#cbd5e1] group-hover:text-[#c5a059] transition-colors">
              <Link to={post.link || "#"}>
                <span dangerouslySetInnerHTML={{
              __html: post.title
            }} />
              </Link>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex-grow">
            <div className="text-muted-foreground text-sm font-sans leading-relaxed line-clamp-4 [&>p]:mb-0" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
          </CardContent>
          <CardFooter className="pt-4 pb-6">
            <Link to={post.link || "#"} className="inline-flex items-center text-sm font-medium text-[#c5a059] underline underline-offset-4 hover:text-[#c5a059]/80 transition-colors">
              Makaleyi Oku
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function LegalArticlesAndUpdates() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="hukuki-makaleler-ve-güncel-bilgiler" className="dark bg-linear-to-br from-[#0a0f1c] to-[#1c1f26] text-foreground py-24 px-4 md:px-8 border-t border-border/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
          <div className="max-w-3xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 tracking-tight text-[#cbd5e1]">
              Hukuki Makaleler ve Güncel Bilgiler
            </h2>
            <p className="text-muted-foreground text-lg font-sans font-light leading-relaxed">
              Hukuk dünyasındaki son gelişmeler, emsal kararlar ve uzmanlık alanlarımıza dair bilgilendirici içeriklerimizle güncel kalın.
            </p>
          </div>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }} className="w-full">
          <ArticlesGrid />
        </PostsProvider>
      </div>
    </section>;
}